import Immutable from 'seamless-immutable';

export const filters = Immutable({
  providers: 'PROVIDER',
  categories: 'CATEGORY',
  status: 'STATUS',
  groups: 'GROUP',
  organizations: 'ORGANIZATION',
  has_active_case: 'HAS_ACTIVE_CASE'
});

export const sections = Immutable({
  participants: 'PARTICIPANT_LIST',
  assessments: 'AGGREGATE_ASSESSMENTS_LIST',
});
